import { atom } from "jotai";
import { TelehealthSessionInfoData } from "../hooks";

export * from "./theme";
export * from "./drawerButtonRefs";
export * from "./useAppDependenciesContext";
export * from "./AppDependenciesContext";

export const sessionInfoAtom = atom<
  TelehealthSessionInfoData["telehealthSessionInfo"] | null
>(null);

export const appointmentInfoAtom = atom(
  (get) => get(sessionInfoAtom)?.appointment ?? null,
);

export const clientUserShortIdAtom = atom(
  (get) => get(appointmentInfoAtom)?.clientUserShortId ?? "",
);
